// layout
import MainLayout from "../Container/Layout/MainLayout";
// style
import styles from "../Styles/Quotes.module.css";
// component
import { useContext, useEffect, useState } from "react";
import { Context } from "../Context/Context";
import {
  Reordering,
  deletService,
  getServiceList,
  manyDeletService,
  repriceService,
  retrieveServicePut,
  sendReadService,
  checkServiceExistsInOneOrder,
} from "../Services/ContectService";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import moment from "jalali-moment";
import Notfound from "../Components/Common/Notfound";
import swal from "sweetalert";
import QuoteImage from "../Components/Common/QuoteImage";

const Quotes = () => {
  const { json, user, setTalkExpert, cartHandeler, loading, setLoading } =
    useContext(Context);
  const content = json?.Quotes;
  let navigate = useNavigate();

  const [tab, setTab] = useState("o");
  const [serviceList, setServiceList] = useState([]);
  const [dataOpen, setDataOpen] = useState([]);
  const [dataAccept, setDataAccept] = useState([]);
  const [dataReject, setDataReject] = useState([]);
  const [dataExpired, setDataExpired] = useState([]);
  const [selectService, setSelectService] = useState([]);
  const [allNameTab, setAllNameTab] = useState([]);

  const [analyzingService, setAnalyzingService] = useState(null);

  let getServiceListTimeout;

  const serviceListHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getServiceList(user);
      if (status === 200) {
        setServiceList(data);
        setAnalyzingService(data.find((item) => item.state === "a"));
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const getNewServiceListHandler = async () => {
    try {
      const { status, data } = await getServiceList(user);
      if (status === 200) {
        const analyzingData = data.find((item) => item.state === "a");
        if (analyzingData) {
          callGetNewServiceListHandler();
        } else {
          const dataCompleteAnalyzing = data.find(
            (item) => item.id === analyzingService.id
          );
          setServiceList((prevValue) =>
            prevValue.map((s) => {
              return s.id === analyzingService.id ? dataCompleteAnalyzing : s;
            })
          );
          setAnalyzingService(null);
        }
      }
    } catch (error) {
      // toast.error(json.toast.err_1);
    }
  };

  const callGetNewServiceListHandler = () => {
    if (getServiceListTimeout) clearTimeout(getServiceListTimeout);
    getServiceListTimeout = setTimeout(() => {
      getNewServiceListHandler();
    }, 12000);
  };

  const serviceDeletHandeler = async (id) => {
    setLoading(true);
    try {
      const { status } = await deletService(user, id);
      if (status === 204) {
        setServiceList((prevList) =>
          prevList.filter((item) => item.code !== id)
        );
        toast.success(json.toast.Quotes_2);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const swalServiceDeletHandeler = async (id) => {
    swal({
      title: json.swal.ServiceDelet.title,
      text: json.swal.ServiceDelet.text,
      icon: "warning",
      buttons: {
        cancel: json.swal.ServiceDelet.button_1,
        yes: json.swal.ServiceDelet.button_2,
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        serviceDeletHandeler(id);
      }
    });
  };

  const swalServiceRetrieveHandeler = async (item) => {
    swal({
      title: json.swal.ServiceRetrieve.title,
      text: json.swal.ServiceRetrieve.text,
      icon: "warning",
      buttons: {
        cancel: json.swal.ServiceRetrieve.button_1,
        yes: json.swal.ServiceRetrieve.button_2,
      },
      dangerMode: true,
    }).then((willReprice) => {
      if (willReprice) {
        repricingHandler(item);
      }
    });
  };

  const repricingHandler = async (item) => {
    setLoading(true);
    try {
      const { status, data } = await repriceService(user, item.code);
      if (status === 200 && data.plan_table.length > 0) {
        serviceRetrieve(data, item);
      } else {
        toast.error("اطلاعاتی برای دریافت وجود ندارد");
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const serviceRetrieve = async (repriceData, selectItem) => {
    setLoading(true);
    let data = {
      code: selectItem.code,
      unit_price: repriceData.unit_price,
      plan_id: selectItem.plan || 1,
      quantity: selectItem.quantity || 1,
      preparation_time: repriceData.time,
      total_price: repriceData.total_price,
    };
    try {
      const { status } = await retrieveServicePut(user, data);
      if (status === 200) {
        toast.success(json.toast.Quotes_1);
        serviceListHandeler();
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const reorderingrHandeler = async (id) => {
    setLoading(true);
    try {
      const { status, data } = await Reordering(user, id);
      if (status === 201) {
        // toast.success(json.toast.Reordering);
        setLoading(false);
        window.location.reload()
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  const swalReorderingrHandeler = async (id) => {
    swal({
      title: json.swal.Reorderingr.title,
      text: json.swal.Reorderingr.text,
      icon: "warning",
      buttons: {
        cancel: json.swal.Reorderingr.button_1,
        yes: json.swal.Reorderingr.button_2,
      },
      dangerMode: true,
    }).then((willReorder) => {
      if (willReorder) {
        reorderingrHandeler(id);
      }
    });
  };

  const selectServiceHandeler = (id, all) => {
    if (all) {
      let nameTab = allNameTab.find((nt) => nt.tab === tab)?.name;
      if (nameTab.length === selectService.length) {
        setSelectService([]);
      } else {
        const newSelectService = [];
        for (let nt of nameTab) {
          newSelectService.push(nt.code);
        }
        setSelectService(newSelectService);
      }
    } else {
      if (selectService.find((item) => item === id)) {
        setSelectService((prevList) => prevList.filter((item) => item !== id));
      } else {
        const newSelectService = [...selectService, id];
        setSelectService(newSelectService);
      }
    }
  };

  const checkSelectAllHandeler = () => {
    let nameTab = allNameTab.find((nt) => nt.tab === tab)?.name;
    if (selectService.length === 0) {
      return false;
    } else if (nameTab.length === selectService.length) {
      return true;
    }
    return false;
  };

  const checkSelectServiceHandeler = (id) => {
    if (selectService.find((item) => item === id)) {
      return true;
    }
    return false;
  };

  const manyServiceDeletHandeler = async () => {
    setLoading(true);
    let newObject = selectService.map((item) => ({
      code: item,
    }));
    try {
      const { status } = await manyDeletService(newObject, user);
      if (status === 200) {
        setServiceList((prevList) =>
          prevList.filter((item) => !selectService.includes(item.code))
        );
        setSelectService([]);
        toast.success(json.toast.Quotes_3);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const swalmanyServiceDeletHandeler = async () => {
    if (selectService.length > 0) {
      swal({
        title: json.swal.manyServiceDelet.title,
        text: json.swal.manyServiceDelet.text,
        icon: "warning",
        buttons: {
          cancel: json.swal.manyServiceDelet.button_1,
          yes: json.swal.manyServiceDelet.button_2,
        },
        dangerMode: true,
      }).then((willDeleteMany) => {
        if (willDeleteMany) {
          manyServiceDeletHandeler();
        }
      });
    } else {
      toast.error(json.toast.Quotes_4);
      setLoading(false);
    }
  };

  const swalmassegHandeler = async (description) => {
    swal({
      title: "توضیحات کارشناس",
      text: description,
      icon: "warning",
      buttons: {
        cancel: "متوجه شدم",
      },
      dangerMode: true,
    });
  };

  const sendReadHandler = async (item) => {
    setLoading(true);
    try {
      const { status } = await sendReadService(user, item.code);
      if (status === 200) {
        setLoading(false);
        return navigate(`/editOrder/${item.code}`);
      }
    } catch (error) {
      setLoading(false);
      toast.error(json.toast.err_1);
    }
  };

  useEffect(() => {
    serviceListHandeler();

    return () => {
      clearTimeout(getServiceListTimeout);
    };
  }, []);

  useEffect(() => {
    if (serviceList.length > 0) {
      setDataOpen(serviceList.filter((item) => item.status === "o"));
      setDataAccept(serviceList.filter((item) => item.status === "a"));
      setDataReject(serviceList.filter((item) => item.status === "r"));
      setDataExpired(serviceList.filter((item) => item.status === "e"));
    }
  }, [serviceList]);

  useEffect(() => {
    let newArray = [
      { tab: "o", name: dataOpen },
      { tab: "a", name: dataAccept },
      { tab: "r", name: dataReject },
      { tab: "e", name: dataExpired },
    ];
    setAllNameTab(newArray);
  }, [dataOpen, dataAccept, dataReject, dataExpired]);

  useEffect(() => {
    if (analyzingService) {
      getNewServiceListHandler();
    }
  }, [analyzingService]);

  return (
    <MainLayout>
      <section className={styles.quotes}>
        <div className={styles.quotesFilter}>
          <p className="flex items-center gap-1">
            <svg
              className="translate-y-[-3px]"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.286 5.98875C29.0901 5.54581 28.7697 5.16931 28.3639 4.90502C27.958 4.64072 27.4841 4.50002 26.9998 4.5H4.99976C4.5155 4.50005 4.04168 4.64074 3.63587 4.90497C3.23006 5.16921 2.90972 5.54561 2.71378 5.98846C2.51785 6.43131 2.45474 6.92153 2.53214 7.39956C2.60953 7.87759 2.8241 8.32285 3.14976 8.68125L3.16476 8.69875L11.4998 17.5938V27C11.4997 27.4526 11.6225 27.8967 11.8551 28.285C12.0876 28.6733 12.4213 28.9912 12.8203 29.2047C13.2194 29.4182 13.669 29.5194 14.1211 29.4974C14.5731 29.4755 15.0108 29.3312 15.3873 29.08L19.3873 26.4137C19.7297 26.1853 20.0105 25.8757 20.2045 25.5127C20.3986 25.1496 20.5 24.7442 20.4998 24.3325V17.5938L28.8335 8.69875L28.8485 8.68125C29.1744 8.32304 29.3892 7.87791 29.4668 7.39993C29.5445 6.92195 29.4817 6.4317 29.286 5.98875ZM18.176 15.6862C17.7408 16.1492 17.4989 16.7609 17.4998 17.3962V24.065L14.4998 26.065V17.3962C14.5007 16.7609 14.2587 16.1492 13.8235 15.6862L6.15351 7.5H25.846L18.176 15.6862Z"
                fill="black"
              />
            </svg>
            {content.filter.title_1}
          </p>
          <p className="ms-2">{content.filter.title_2}</p>
          <div className="input-frame input-frame-two">
            <select id="CNC">
              {content.filter.item.map((item, index) => (
                <option key={index}>{item}</option>
              ))}
            </select>
          </div>
        </div>
        <div className={styles.quotesTab}>
          <button
            className={tab === "o" ? styles.active : null}
            onClick={() => {
              setTab("o");
              setSelectService([]);
            }}
          >
            <p>{content.quotesTab[0]}</p>
            <div>{dataOpen.length}</div>
          </button>
          <button
            className={tab === "a" ? styles.active : null}
            onClick={() => {
              setTab("a");
              setSelectService([]);
            }}
          >
            <p>{content.quotesTab[1]}</p>
            <div>{dataAccept.length}</div>
          </button>
          <button
            className={tab === "r" ? styles.active : null}
            onClick={() => {
              setTab("r");
              setSelectService([]);
            }}
          >
            <p>{content.quotesTab[2]}</p>
            <div>{dataReject.length}</div>
          </button>
          <button
            className={tab === "e" ? styles.active : null}
            onClick={() => {
              setTab("e");
              setSelectService([]);
            }}
          >
            <p>{content.quotesTab[3]}</p>
            <div>{dataExpired.length}</div>
          </button>
        </div>
        <div className={styles.quotesQuickAccess}>
          <button onClick={() => selectServiceHandeler("", true)}>
            <input
              type="checkbox"
              id="all"
              checked={checkSelectAllHandeler()}
              onChange={() => {}}
            />
            <label style={{ cursor: "pointer" }} htmlFor="all">
              {content.quickAccess[0]}
            </label>
          </button>
          <button onClick={swalmanyServiceDeletHandeler}>
            {content.quickAccess[1]}
            <svg
              width="24"
              height="24"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                fill="black"
              />
            </svg>
          </button>
          <Link to="/">
            {content.quickAccess[2]}
            <svg
              width="24"
              height="24"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 2.5C13.33 2.5 10.7199 3.29176 8.49981 4.77516C6.27974 6.25856 4.54942 8.36697 3.52763 10.8338C2.50585 13.3006 2.2385 16.015 2.7594 18.6337C3.28031 21.2525 4.56606 23.6579 6.45406 25.5459C8.34207 27.434 10.7475 28.7197 13.3663 29.2406C15.985 29.7615 18.6994 29.4942 21.1662 28.4724C23.633 27.4506 25.7414 25.7203 27.2248 23.5002C28.7082 21.2801 29.5 18.67 29.5 16C29.496 12.4208 28.0724 8.98932 25.5416 6.45844C23.0107 3.92756 19.5792 2.50397 16 2.5ZM16 26.5C13.9233 26.5 11.8932 25.8842 10.1665 24.7304C8.4398 23.5767 7.09399 21.9368 6.29927 20.0182C5.50455 18.0996 5.29662 15.9884 5.70176 13.9516C6.10691 11.9148 7.10693 10.0438 8.57538 8.57538C10.0438 7.10693 11.9148 6.1069 13.9516 5.70175C15.9884 5.29661 18.0996 5.50454 20.0182 6.29926C21.9368 7.09399 23.5767 8.4398 24.7304 10.1665C25.8842 11.8932 26.5 13.9233 26.5 16C26.497 18.7839 25.3898 21.4528 23.4213 23.4213C21.4529 25.3898 18.7839 26.497 16 26.5ZM22.5 16C22.5 16.3978 22.342 16.7794 22.0607 17.0607C21.7794 17.342 21.3978 17.5 21 17.5H17.5V21C17.5 21.3978 17.342 21.7794 17.0607 22.0607C16.7794 22.342 16.3978 22.5 16 22.5C15.6022 22.5 15.2206 22.342 14.9393 22.0607C14.658 21.7794 14.5 21.3978 14.5 21V17.5H11C10.6022 17.5 10.2207 17.342 9.93935 17.0607C9.65804 16.7794 9.50001 16.3978 9.50001 16C9.50001 15.6022 9.65804 15.2206 9.93935 14.9393C10.2207 14.658 10.6022 14.5 11 14.5H14.5V11C14.5 10.6022 14.658 10.2206 14.9393 9.93934C15.2206 9.65804 15.6022 9.5 16 9.5C16.3978 9.5 16.7794 9.65804 17.0607 9.93934C17.342 10.2206 17.5 10.6022 17.5 11V14.5H21C21.3978 14.5 21.7794 14.658 22.0607 14.9393C22.342 15.2206 22.5 15.6022 22.5 16Z"
                fill="black"
              />
            </svg>
          </Link>
        </div>
        {tab === "o" ? (
          <div className={styles.quotesBody}>
            {loading ? (
              <div className="d-flex justify-content-center px-2 py-5 h3">
                لطفاً صبر کنید...
              </div>
            ) : dataOpen.length > 0 ? (
              dataOpen.map((item, index) => (
                <div className={styles.quotesItem} key={index}>
                  <button>
                    <input
                      type="checkbox"
                      id={index}
                      name={index}
                      checked={checkSelectServiceHandeler(item.code)}
                      onChange={() => selectServiceHandeler(item.code)}
                    />
                    <label htmlFor={index}>
                      {content.quotesitem.service} {index + 1}{" "}
                    </label>
                  </button>
                  <div className={styles.quotesItemBody}>
                    <div className={styles.quotesItemInfo}>
                      <div>
                        <p>
                          {content.quotesitem.ordercode}&nbsp;
                          {item.code}
                        </p>
                        <p>
                          {content.quotesitem.producttype}&nbsp; ماشین کاری cnc
                        </p>
                        <p>
                          {content.quotesitem.datepreparation}&nbsp;
                          {item.preparation_time
                            ? `${item.preparation_time} روز کاری`
                            : "مشخص نشده"}
                        </p>
                        <p>
                          {content.quotesitem.number}&nbsp;
                          {item.quantity}
                        </p>
                        <p>
                          {content.quotesitem.unitprice}&nbsp;
                          <span
                            className={`${
                              !item.unit_price ? "text-primary" : ""
                            }`}
                          >
                            {item.unit_price
                              ? Number.isNaN(Number(item.unit_price))
                                ? item.unit_price
                                : `${Number(
                                    item.unit_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                        <p>
                          {content.quotesitem.totalprice}&nbsp;
                          <span
                            className={`${
                              !item.total_price ? "text-primary" : ""
                            }`}
                          >
                            {item.total_price
                              ? Number.isNaN(Number(item.total_price))
                                ? item.total_price
                                : `${Number(
                                    item.total_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          {content.quotesitem.dateregistration}&nbsp;
                          {item.created_at
                            ? moment(item.created_at, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                      </div>
                      <div>
                        {item.is_offline === "0" ? (
                          <button className={styles.success}>
                            بررسی اتوماتیک و آنلاین
                          </button>
                        ) : (
                          <button className={styles.warning}>
                            بررسی آفلاین توسط کارشناس
                          </button>
                        )}
                        <button
                          onClick={() => swalServiceDeletHandeler(item.code)}
                        >
                          {content.quotesitem.removequote}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button className="color-neutral-500">
                          {content.quotesitem.requotation}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30.5009 6.99998V13C30.5009 13.3978 30.3429 13.7793 30.0616 14.0606C29.7803 14.3419 29.3988 14.5 29.0009 14.5H23.0009C22.6031 14.5 22.2216 14.3419 21.9403 14.0606C21.659 13.7793 21.5009 13.3978 21.5009 13C21.5009 12.6022 21.659 12.2206 21.9403 11.9393C22.2216 11.658 22.6031 11.5 23.0009 11.5H25.1384L22.7634 9.32748C22.7472 9.31248 22.7309 9.29748 22.7159 9.28123C21.6147 8.18068 20.2599 7.36764 18.7706 6.91365C17.2814 6.45967 15.7034 6.37865 14.1755 6.67773C12.6476 6.97681 11.2167 7.64682 10.0085 8.6288C8.80036 9.61079 7.85207 10.8747 7.24708 12.3092C6.64208 13.7437 6.39893 15.305 6.53901 16.8555C6.67909 18.4061 7.19811 19.8985 8.0504 21.2014C8.9027 22.5043 10.0621 23.5777 11.4267 24.3273C12.7913 25.0769 14.3192 25.4796 15.8759 25.5H16.0009C18.4258 25.5058 20.76 24.5784 22.5197 22.91C22.8089 22.6366 23.1949 22.4894 23.5927 22.5007C23.9906 22.5119 24.3676 22.6807 24.6409 22.97C24.9143 23.2592 25.0615 23.6452 25.0503 24.043C25.039 24.4408 24.8702 24.8179 24.5809 25.0912C22.2645 27.2867 19.1925 28.5073 16.0009 28.5H15.8297C13.7835 28.4711 11.7757 27.9404 9.98254 26.9543C8.1894 25.9682 6.66578 24.557 5.54546 22.8445C4.42514 21.132 3.7424 19.1706 3.55717 17.1326C3.37195 15.0946 3.68991 13.0423 4.48314 11.1559C5.27637 9.26953 6.5206 7.60673 8.10659 6.31352C9.69257 5.02032 11.5718 4.13628 13.5793 3.73902C15.5867 3.34176 17.661 3.44343 19.62 4.03511C21.579 4.62679 23.3628 5.69037 24.8147 7.13248L27.5009 9.58998V6.99998C27.5009 6.60216 27.659 6.22062 27.9403 5.93932C28.2216 5.65802 28.6031 5.49998 29.0009 5.49998C29.3988 5.49998 29.7803 5.65802 30.0616 5.93932C30.3429 6.22062 30.5009 6.60216 30.5009 6.99998Z"
                              fill="#7F7F7F"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => swalReorderingrHandeler(item.code)}
                        >
                          {content.quotesitem.copyquote}

                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 3.5H11C10.6022 3.5 10.2206 3.65804 9.93934 3.93934C9.65804 4.22064 9.5 4.60218 9.5 5V9.5H5C4.60218 9.5 4.22064 9.65804 3.93934 9.93934C3.65804 10.2206 3.5 10.6022 3.5 11V27C3.5 27.3978 3.65804 27.7794 3.93934 28.0607C4.22064 28.342 4.60218 28.5 5 28.5H21C21.3978 28.5 21.7794 28.342 22.0607 28.0607C22.342 27.7794 22.5 27.3978 22.5 27V22.5H27C27.3978 22.5 27.7794 22.342 28.0607 22.0607C28.342 21.7794 28.5 21.3978 28.5 21V5C28.5 4.60218 28.342 4.22064 28.0607 3.93934C27.7794 3.65804 27.3978 3.5 27 3.5ZM19.5 25.5H6.5V12.5H19.5V25.5ZM25.5 19.5H22.5V11C22.5 10.6022 22.342 10.2206 22.0607 9.93934C21.7794 9.65804 21.3978 9.5 21 9.5H12.5V6.5H25.5V19.5Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => {
                            setTalkExpert(item.code);
                            navigate(`/DetailsTicket/${item.ticket_code}`)
                          }}
                        >
                          {content.quotesitem.talkexpert}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.5001 13.5C21.5001 13.8978 21.342 14.2793 21.0607 14.5606C20.7794 14.8419 20.3979 15 20.0001 15H12.0001C11.6022 15 11.2207 14.8419 10.9394 14.5606C10.6581 14.2793 10.5001 13.8978 10.5001 13.5C10.5001 13.1021 10.6581 12.7206 10.9394 12.4393C11.2207 12.158 11.6022 12 12.0001 12H20.0001C20.3979 12 20.7794 12.158 21.0607 12.4393C21.342 12.7206 21.5001 13.1021 21.5001 13.5ZM20.0001 17H12.0001C11.6022 17 11.2207 17.158 10.9394 17.4393C10.6581 17.7206 10.5001 18.1021 10.5001 18.5C10.5001 18.8978 10.6581 19.2793 10.9394 19.5606C11.2207 19.8419 11.6022 20 12.0001 20H20.0001C20.3979 20 20.7794 19.8419 21.0607 19.5606C21.342 19.2793 21.5001 18.8978 21.5001 18.5C21.5001 18.1021 21.342 17.7206 21.0607 17.4393C20.7794 17.158 20.3979 17 20.0001 17ZM29.5001 16C29.5006 18.3124 28.907 20.5862 27.7764 22.6034C26.6458 24.6206 25.0159 26.3136 23.0431 27.52C21.0703 28.7264 18.8207 29.4059 16.5099 29.4932C14.199 29.5805 11.9045 29.0728 9.84631 28.0187L5.79257 29.375C5.35127 29.5237 4.8772 29.5462 4.42379 29.44C3.97038 29.3337 3.55566 29.103 3.22637 28.7737C2.89708 28.4444 2.66631 28.0297 2.56007 27.5762C2.45383 27.1228 2.47634 26.6488 2.62507 26.2075L3.97632 22.1537C3.04843 20.3362 2.54466 18.3319 2.5029 16.2917C2.46114 14.2514 2.88246 12.2282 3.7352 10.3742C4.58793 8.52022 5.84988 6.88368 7.42617 5.58762C9.00245 4.29157 10.8521 3.36974 12.8359 2.89143C14.8198 2.41313 16.8862 2.3908 18.8799 2.82613C20.8737 3.26146 22.7428 4.14311 24.3467 5.40481C25.9506 6.6665 27.2476 8.2754 28.1402 10.1105C29.0328 11.9457 29.4977 13.9593 29.5001 16ZM26.5001 16C26.4995 14.3894 26.1283 12.8006 25.4155 11.3564C24.7026 9.91215 23.667 8.65129 22.3889 7.67133C21.1107 6.69136 19.6243 6.01856 18.0446 5.70495C16.4648 5.39135 14.8341 5.44536 13.2786 5.8628C11.7231 6.28024 10.2844 7.04993 9.07391 8.11232C7.86343 9.1747 6.91356 10.5013 6.29779 11.9895C5.68202 13.4777 5.41686 15.0877 5.52281 16.6947C5.62876 18.3018 6.10299 19.863 6.90882 21.2575C7.01532 21.4414 7.08154 21.6458 7.10309 21.8572C7.12464 22.0686 7.10103 22.2821 7.03382 22.4837L5.79257 26.2075L9.51631 24.9662C9.6695 24.9152 9.82986 24.889 9.99132 24.8887C10.2548 24.8892 10.5134 24.959 10.7413 25.0912C12.3376 26.0149 14.149 26.5018 15.9932 26.503C17.8375 26.5042 19.6495 26.0196 21.247 25.098C22.8445 24.1765 24.171 22.8504 25.0932 21.2532C26.0154 19.6561 26.5006 17.8442 26.5001 16Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className={styles.quotesItemImg}>
                      {item.state === "a" ? (
                        <div
                          className="w-full h-full 
                                                    flex justify-center items-center p-10"
                        >
                          <div
                            className="spinner-border text-primary 
                                                            w-[50px] h-[50px]"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        </div>
                      ) : item.image ? (
                        <QuoteImage code={item.code} />
                      ) : (
                        <img
                          src="/imgs/upload/wisercam image.png"
                          alt="Service"
                        />
                      )}
                    </div>
                    <div className={styles.quotesAttribute}>
                      <div>
                        {item.state === "a"
                          ? content.quotesitem.price_info_1
                          : item.state === "w"
                          ? content.quotesitem.price_info_2
                          : item.state === "o" &&
                            content.quotesitem.price_info_3}
                      </div>
                      <div>
                        {item.is_offline == "1" && (
                          <p className={styles.quotesAttributeOffline}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                                fill="#E98862"
                              />
                            </svg>
                            {content.quotesitem.info_1}
                          </p>
                        )}
                        <p>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#367CFF"
                            />
                          </svg>
                          {item.state === "a" ? (
                            <>
                              در حال تحلیل فایل شما هستیم. این فرایند ممکن است
                              چند دقیقه طول بکشد. لطفاً منتظر بمانید.
                            </>
                          ) : (
                            <>
                              {/* {content.quotesitem.info_2} */}
                              لطفاً برای مشاهده‌ی قیمت و تایید پارامترهای ساخت،
                              از قسمت مشاهده و ویرایش اقدام نمایید.
                            </>
                          )}
                        </p>
                      </div>
                      <div>
                        <button
                          onClick={() => sendReadHandler(item)}
                          className="main-btn main-btn-fill disabled:bg-neutral-500"
                          disabled={item.state === "a"}
                        >
                          مشاهده و ویرایش
                          <svg
                            className="d-none d-md-flex"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <button
                          className="main-btn main-btn-fill disabled:bg-neutral-500"
                          disabled
                        >
                          {content.quotesitem.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Notfound />
            )}
          </div>
        ) : null}
        {tab === "a" ? (
          <div className={styles.quotesBody}>
            {loading ? (
              <div className="d-flex justify-content-center px-2 py-5 h3">
                لطفاً صبر کنید...
              </div>
            ) : dataAccept.length > 0 ? (
              dataAccept.map((item, index) => (
                <div className={styles.quotesItem} key={index}>
                  <button>
                    <input
                      type="checkbox"
                      id={index}
                      name={index}
                      checked={checkSelectServiceHandeler(item.code)}
                      onChange={() => selectServiceHandeler(item.code)}
                    />
                    <label htmlFor={index}>
                      {content.quotesitem.service} {index + 1}{" "}
                    </label>
                  </button>
                  <div className={styles.quotesItemBody}>
                    <div className={styles.quotesItemInfo}>
                      <div>
                        <p>
                          {content.quotesitem.ordercode}&nbsp;
                          {item.code}
                        </p>
                        <p>
                          {content.quotesitem.producttype}&nbsp; ماشین کاری cnc
                        </p>
                        <p>
                          {content.quotesitem.datepreparation}&nbsp;
                          {item.preparation_time
                            ? `${item.preparation_time} روز کاری`
                            : "مشخص نشده"}
                        </p>
                        <p>
                          {content.quotesitem.number}&nbsp;
                          {item.quantity}
                        </p>
                        <p>
                          {content.quotesitem.unitprice}&nbsp;
                          <span
                            className={`${
                              !item.unit_price ? "text-primary" : ""
                            }`}
                          >
                            {item.unit_price
                              ? Number.isNaN(Number(item.unit_price))
                                ? item.unit_price
                                : `${Number(
                                    item.unit_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                        <p>
                          {content.quotesitem.totalprice}&nbsp;
                          <span
                            className={`${
                              !item.total_price ? "text-primary" : ""
                            }`}
                          >
                            {item.total_price
                              ? Number.isNaN(Number(item.total_price))
                                ? item.total_price
                                : `${Number(
                                    item.total_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          {content.quotesitem.dateregistration}&nbsp;
                          {item.created_at
                            ? moment(item.created_at, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                        <p>
                          تاریخ تایید :&nbsp;
                          {item.accept_date
                            ? moment(item.accept_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                        {item.is_offline === "0" ? null : (
                          <button
                            onClick={() =>
                              swalmassegHandeler(item.admin_description)
                            }
                            className={styles.warning_item}
                          >
                            توضیحات کارشناس
                          </button>
                        )}
                        {item.is_offline === "0" ? null : (
                          <div className="d-flex gap-2 align-items-center">
                            <input type="checkbox" id="accept" />
                            <label
                              htmlFor="accept"
                              style={{ cursor: "pointer" }}
                            >
                              توضیحات و شرایط را می‌پذیرم.
                            </label>
                          </div>
                        )}
                      </div>
                      <div>
                        {item.is_offline === "0" ? (
                          <button className={styles.success}>
                            بررسی اتوماتیک و آنلاین
                          </button>
                        ) : (
                          <button className={styles.warning}>
                            بررسی آفلاین توسط کارشناس
                          </button>
                        )}
                        <button
                          onClick={() => swalServiceDeletHandeler(item.code)}
                        >
                          {content.quotesitem.removequote}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        {/* <button className="color-neutral-500">
                                                        {content.quotesitem.removequote}
                                                        <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z" fill="#7F7F7F" />
                                                        </svg>
                                                    </button> */}
                        <button className="color-neutral-500">
                          {content.quotesitem.requotation}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30.5009 6.99998V13C30.5009 13.3978 30.3429 13.7793 30.0616 14.0606C29.7803 14.3419 29.3988 14.5 29.0009 14.5H23.0009C22.6031 14.5 22.2216 14.3419 21.9403 14.0606C21.659 13.7793 21.5009 13.3978 21.5009 13C21.5009 12.6022 21.659 12.2206 21.9403 11.9393C22.2216 11.658 22.6031 11.5 23.0009 11.5H25.1384L22.7634 9.32748C22.7472 9.31248 22.7309 9.29748 22.7159 9.28123C21.6147 8.18068 20.2599 7.36764 18.7706 6.91365C17.2814 6.45967 15.7034 6.37865 14.1755 6.67773C12.6476 6.97681 11.2167 7.64682 10.0085 8.6288C8.80036 9.61079 7.85207 10.8747 7.24708 12.3092C6.64208 13.7437 6.39893 15.305 6.53901 16.8555C6.67909 18.4061 7.19811 19.8985 8.0504 21.2014C8.9027 22.5043 10.0621 23.5777 11.4267 24.3273C12.7913 25.0769 14.3192 25.4796 15.8759 25.5H16.0009C18.4258 25.5058 20.76 24.5784 22.5197 22.91C22.8089 22.6366 23.1949 22.4894 23.5927 22.5007C23.9906 22.5119 24.3676 22.6807 24.6409 22.97C24.9143 23.2592 25.0615 23.6452 25.0503 24.043C25.039 24.4408 24.8702 24.8179 24.5809 25.0912C22.2645 27.2867 19.1925 28.5073 16.0009 28.5H15.8297C13.7835 28.4711 11.7757 27.9404 9.98254 26.9543C8.1894 25.9682 6.66578 24.557 5.54546 22.8445C4.42514 21.132 3.7424 19.1706 3.55717 17.1326C3.37195 15.0946 3.68991 13.0423 4.48314 11.1559C5.27637 9.26953 6.5206 7.60673 8.10659 6.31352C9.69257 5.02032 11.5718 4.13628 13.5793 3.73902C15.5867 3.34176 17.661 3.44343 19.62 4.03511C21.579 4.62679 23.3628 5.69037 24.8147 7.13248L27.5009 9.58998V6.99998C27.5009 6.60216 27.659 6.22062 27.9403 5.93932C28.2216 5.65802 28.6031 5.49998 29.0009 5.49998C29.3988 5.49998 29.7803 5.65802 30.0616 5.93932C30.3429 6.22062 30.5009 6.60216 30.5009 6.99998Z"
                              fill="#7F7F7F"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => swalReorderingrHandeler(item.code)}
                        >
                          {content.quotesitem.copyquote}

                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 3.5H11C10.6022 3.5 10.2206 3.65804 9.93934 3.93934C9.65804 4.22064 9.5 4.60218 9.5 5V9.5H5C4.60218 9.5 4.22064 9.65804 3.93934 9.93934C3.65804 10.2206 3.5 10.6022 3.5 11V27C3.5 27.3978 3.65804 27.7794 3.93934 28.0607C4.22064 28.342 4.60218 28.5 5 28.5H21C21.3978 28.5 21.7794 28.342 22.0607 28.0607C22.342 27.7794 22.5 27.3978 22.5 27V22.5H27C27.3978 22.5 27.7794 22.342 28.0607 22.0607C28.342 21.7794 28.5 21.3978 28.5 21V5C28.5 4.60218 28.342 4.22064 28.0607 3.93934C27.7794 3.65804 27.3978 3.5 27 3.5ZM19.5 25.5H6.5V12.5H19.5V25.5ZM25.5 19.5H22.5V11C22.5 10.6022 22.342 10.2206 22.0607 9.93934C21.7794 9.65804 21.3978 9.5 21 9.5H12.5V6.5H25.5V19.5Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => {
                            setTalkExpert(item.code);
                            navigate(`/DetailsTicket/${item.ticket_code}`);
                          }}
                        >
                          {content.quotesitem.talkexpert}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.5001 13.5C21.5001 13.8978 21.342 14.2793 21.0607 14.5606C20.7794 14.8419 20.3979 15 20.0001 15H12.0001C11.6022 15 11.2207 14.8419 10.9394 14.5606C10.6581 14.2793 10.5001 13.8978 10.5001 13.5C10.5001 13.1021 10.6581 12.7206 10.9394 12.4393C11.2207 12.158 11.6022 12 12.0001 12H20.0001C20.3979 12 20.7794 12.158 21.0607 12.4393C21.342 12.7206 21.5001 13.1021 21.5001 13.5ZM20.0001 17H12.0001C11.6022 17 11.2207 17.158 10.9394 17.4393C10.6581 17.7206 10.5001 18.1021 10.5001 18.5C10.5001 18.8978 10.6581 19.2793 10.9394 19.5606C11.2207 19.8419 11.6022 20 12.0001 20H20.0001C20.3979 20 20.7794 19.8419 21.0607 19.5606C21.342 19.2793 21.5001 18.8978 21.5001 18.5C21.5001 18.1021 21.342 17.7206 21.0607 17.4393C20.7794 17.158 20.3979 17 20.0001 17ZM29.5001 16C29.5006 18.3124 28.907 20.5862 27.7764 22.6034C26.6458 24.6206 25.0159 26.3136 23.0431 27.52C21.0703 28.7264 18.8207 29.4059 16.5099 29.4932C14.199 29.5805 11.9045 29.0728 9.84631 28.0187L5.79257 29.375C5.35127 29.5237 4.8772 29.5462 4.42379 29.44C3.97038 29.3337 3.55566 29.103 3.22637 28.7737C2.89708 28.4444 2.66631 28.0297 2.56007 27.5762C2.45383 27.1228 2.47634 26.6488 2.62507 26.2075L3.97632 22.1537C3.04843 20.3362 2.54466 18.3319 2.5029 16.2917C2.46114 14.2514 2.88246 12.2282 3.7352 10.3742C4.58793 8.52022 5.84988 6.88368 7.42617 5.58762C9.00245 4.29157 10.8521 3.36974 12.8359 2.89143C14.8198 2.41313 16.8862 2.3908 18.8799 2.82613C20.8737 3.26146 22.7428 4.14311 24.3467 5.40481C25.9506 6.6665 27.2476 8.2754 28.1402 10.1105C29.0328 11.9457 29.4977 13.9593 29.5001 16ZM26.5001 16C26.4995 14.3894 26.1283 12.8006 25.4155 11.3564C24.7026 9.91215 23.667 8.65129 22.3889 7.67133C21.1107 6.69136 19.6243 6.01856 18.0446 5.70495C16.4648 5.39135 14.8341 5.44536 13.2786 5.8628C11.7231 6.28024 10.2844 7.04993 9.07391 8.11232C7.86343 9.1747 6.91356 10.5013 6.29779 11.9895C5.68202 13.4777 5.41686 15.0877 5.52281 16.6947C5.62876 18.3018 6.10299 19.863 6.90882 21.2575C7.01532 21.4414 7.08154 21.6458 7.10309 21.8572C7.12464 22.0686 7.10103 22.2821 7.03382 22.4837L5.79257 26.2075L9.51631 24.9662C9.6695 24.9152 9.82986 24.889 9.99132 24.8887C10.2548 24.8892 10.5134 24.959 10.7413 25.0912C12.3376 26.0149 14.149 26.5018 15.9932 26.503C17.8375 26.5042 19.6495 26.0196 21.247 25.098C22.8445 24.1765 24.171 22.8504 25.0932 21.2532C26.0154 19.6561 26.5006 17.8442 26.5001 16Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className={styles.quotesItemImg}>
                      {item.image ? (
                        <QuoteImage code={item.code} />
                      ) : (
                        <img
                          src="/imgs/upload/wisercam image.png"
                          alt="Service"
                        />
                      )}
                    </div>
                    <div className={styles.quotesAttribute}>
                      <div>در انتظار ثبت سفارش</div>
                      <div>
                        <p className={styles.quotesAttributeOffline}>
                          {item.is_offline === "1" && (
                            <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                                  fill="#E98862"
                                />
                              </svg>
                              ثبت سفارش به معنای پذیرش توضیحات و شرایط کارشناس
                              است.
                            </span>
                          )}
                        </p>
                        <p>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#367CFF"
                            />
                          </svg>
                          برای ثبت نهایی سفارش، مظنه را به سبد خرید خود اضافه
                          کنید. در صورت عدم ثبت سفارش، مظنه شما پس از گذشت چند
                          روز منقضی خواهد شد.
                        </p>
                      </div>
                      <div>
                        <Link
                          to={`/DetailOrder/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.quotesitem.button_1}
                          <svg
                            className="d-none d-md-flex"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                              fill="white"
                            />
                          </svg>
                        </Link>
                        <button
                          onClick={() => {
                              checkServiceExistsInOneOrder(user, item.code)
                              .then((res) => {
                                if (res.status === 200) {
                                  cartHandeler(item.code)
                                }
                              })
                              .catch((err) => {
                                  if (err.response?.status === 400) {
                                    toast.error("این مظنه در یک سفارش وجود دارد، لطفا از مظنه کپی بگیرید و مجددا تلاش کنید")
                                  }
                                  else {
                                    toast.error(json.toast.err_1);
                                  }
                              })
                            }}
                          className="main-btn main-btn-fill"
                        >
                          {content.quotesitem.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Notfound />
            )}
          </div>
        ) : null}
        {tab === "r" ? (
          <div className={styles.quotesBody}>
            {loading ? (
              <div className="d-flex justify-content-center px-2 py-5 h3">
                لطفاً صبر کنید...
              </div>
            ) : dataReject.length > 0 ? (
              dataReject.map((item, index) => (
                <div className={styles.quotesItem} key={index}>
                  <button>
                    <input
                      type="checkbox"
                      id={index}
                      name={index}
                      checked={checkSelectServiceHandeler(item.code)}
                      onChange={() => selectServiceHandeler(item.code)}
                    />
                    <label htmlFor={index}>
                      {content.quotesitem.service} {index + 1}{" "}
                    </label>
                  </button>
                  <div className={styles.quotesItemBody}>
                    <div className={styles.quotesItemInfo}>
                      <div>
                        <p>
                          {content.quotesitem.ordercode}&nbsp;
                          {item.code}
                        </p>
                        <p>
                          {content.quotesitem.producttype}&nbsp; ماشین کاری cnc
                        </p>
                        <p>
                          {content.quotesitem.datepreparation}&nbsp;
                          {item.preparation_time
                            ? `${item.preparation_time} روز کاری`
                            : "مشخص نشده"}
                        </p>
                        <p>
                          {content.quotesitem.number}&nbsp;
                          {item.quantity}
                        </p>
                        <p>
                          {content.quotesitem.unitprice}&nbsp;
                          <span
                            className={`${
                              !item.unit_price ? "text-primary" : ""
                            }`}
                          >
                            {item.unit_price
                              ? Number.isNaN(Number(item.unit_price))
                                ? item.unit_price
                                : `${Number(
                                    item.unit_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                        <p>
                          {content.quotesitem.totalprice}&nbsp;
                          <span
                            className={`${
                              !item.total_price ? "text-primary" : ""
                            }`}
                          >
                            {item.total_price
                              ? Number.isNaN(Number(item.total_price))
                                ? item.total_price
                                : `${Number(
                                    item.total_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          {content.quotesitem.dateregistration}&nbsp;
                          {item.created_at
                            ? moment(item.created_at, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                        <button
                          onClick={() =>
                            swalmassegHandeler(item.admin_description)
                          }
                          className={styles.warning_item}
                        >
                          توضیحات کارشناس
                        </button>
                      </div>
                      <div>
                        {item.is_offline === "0" ? (
                          <button className={styles.success}>
                            بررسی اتوماتیک و آنلاین
                          </button>
                        ) : (
                          <button className={styles.warning}>
                            بررسی آفلاین توسط کارشناس
                          </button>
                        )}
                        <button
                          onClick={() => swalServiceDeletHandeler(item.code)}
                        >
                          {content.quotesitem.removequote}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button className="color-neutral-500">
                          {content.quotesitem.requotation}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30.5009 6.99998V13C30.5009 13.3978 30.3429 13.7793 30.0616 14.0606C29.7803 14.3419 29.3988 14.5 29.0009 14.5H23.0009C22.6031 14.5 22.2216 14.3419 21.9403 14.0606C21.659 13.7793 21.5009 13.3978 21.5009 13C21.5009 12.6022 21.659 12.2206 21.9403 11.9393C22.2216 11.658 22.6031 11.5 23.0009 11.5H25.1384L22.7634 9.32748C22.7472 9.31248 22.7309 9.29748 22.7159 9.28123C21.6147 8.18068 20.2599 7.36764 18.7706 6.91365C17.2814 6.45967 15.7034 6.37865 14.1755 6.67773C12.6476 6.97681 11.2167 7.64682 10.0085 8.6288C8.80036 9.61079 7.85207 10.8747 7.24708 12.3092C6.64208 13.7437 6.39893 15.305 6.53901 16.8555C6.67909 18.4061 7.19811 19.8985 8.0504 21.2014C8.9027 22.5043 10.0621 23.5777 11.4267 24.3273C12.7913 25.0769 14.3192 25.4796 15.8759 25.5H16.0009C18.4258 25.5058 20.76 24.5784 22.5197 22.91C22.8089 22.6366 23.1949 22.4894 23.5927 22.5007C23.9906 22.5119 24.3676 22.6807 24.6409 22.97C24.9143 23.2592 25.0615 23.6452 25.0503 24.043C25.039 24.4408 24.8702 24.8179 24.5809 25.0912C22.2645 27.2867 19.1925 28.5073 16.0009 28.5H15.8297C13.7835 28.4711 11.7757 27.9404 9.98254 26.9543C8.1894 25.9682 6.66578 24.557 5.54546 22.8445C4.42514 21.132 3.7424 19.1706 3.55717 17.1326C3.37195 15.0946 3.68991 13.0423 4.48314 11.1559C5.27637 9.26953 6.5206 7.60673 8.10659 6.31352C9.69257 5.02032 11.5718 4.13628 13.5793 3.73902C15.5867 3.34176 17.661 3.44343 19.62 4.03511C21.579 4.62679 23.3628 5.69037 24.8147 7.13248L27.5009 9.58998V6.99998C27.5009 6.60216 27.659 6.22062 27.9403 5.93932C28.2216 5.65802 28.6031 5.49998 29.0009 5.49998C29.3988 5.49998 29.7803 5.65802 30.0616 5.93932C30.3429 6.22062 30.5009 6.60216 30.5009 6.99998Z"
                              fill="#7F7F7F"
                            />
                          </svg>
                        </button>
                        <button className="color-neutral-500">
                          {content.quotesitem.copyquote}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 3.5H11C10.6022 3.5 10.2206 3.65804 9.93934 3.93934C9.65804 4.22064 9.5 4.60218 9.5 5V9.5H5C4.60218 9.5 4.22064 9.65804 3.93934 9.93934C3.65804 10.2206 3.5 10.6022 3.5 11V27C3.5 27.3978 3.65804 27.7794 3.93934 28.0607C4.22064 28.342 4.60218 28.5 5 28.5H21C21.3978 28.5 21.7794 28.342 22.0607 28.0607C22.342 27.7794 22.5 27.3978 22.5 27V22.5H27C27.3978 22.5 27.7794 22.342 28.0607 22.0607C28.342 21.7794 28.5 21.3978 28.5 21V5C28.5 4.60218 28.342 4.22064 28.0607 3.93934C27.7794 3.65804 27.3978 3.5 27 3.5ZM19.5 25.5H6.5V12.5H19.5V25.5ZM25.5 19.5H22.5V11C22.5 10.6022 22.342 10.2206 22.0607 9.93934C21.7794 9.65804 21.3978 9.5 21 9.5H12.5V6.5H25.5V19.5Z"
                              fill="#7F7F7F"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => {
                            setTalkExpert(item.code);
                            navigate(`/DetailsTicket/${item.ticket_code}`);
                          }}
                        >
                          {content.quotesitem.talkexpert}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.5001 13.5C21.5001 13.8978 21.342 14.2793 21.0607 14.5606C20.7794 14.8419 20.3979 15 20.0001 15H12.0001C11.6022 15 11.2207 14.8419 10.9394 14.5606C10.6581 14.2793 10.5001 13.8978 10.5001 13.5C10.5001 13.1021 10.6581 12.7206 10.9394 12.4393C11.2207 12.158 11.6022 12 12.0001 12H20.0001C20.3979 12 20.7794 12.158 21.0607 12.4393C21.342 12.7206 21.5001 13.1021 21.5001 13.5ZM20.0001 17H12.0001C11.6022 17 11.2207 17.158 10.9394 17.4393C10.6581 17.7206 10.5001 18.1021 10.5001 18.5C10.5001 18.8978 10.6581 19.2793 10.9394 19.5606C11.2207 19.8419 11.6022 20 12.0001 20H20.0001C20.3979 20 20.7794 19.8419 21.0607 19.5606C21.342 19.2793 21.5001 18.8978 21.5001 18.5C21.5001 18.1021 21.342 17.7206 21.0607 17.4393C20.7794 17.158 20.3979 17 20.0001 17ZM29.5001 16C29.5006 18.3124 28.907 20.5862 27.7764 22.6034C26.6458 24.6206 25.0159 26.3136 23.0431 27.52C21.0703 28.7264 18.8207 29.4059 16.5099 29.4932C14.199 29.5805 11.9045 29.0728 9.84631 28.0187L5.79257 29.375C5.35127 29.5237 4.8772 29.5462 4.42379 29.44C3.97038 29.3337 3.55566 29.103 3.22637 28.7737C2.89708 28.4444 2.66631 28.0297 2.56007 27.5762C2.45383 27.1228 2.47634 26.6488 2.62507 26.2075L3.97632 22.1537C3.04843 20.3362 2.54466 18.3319 2.5029 16.2917C2.46114 14.2514 2.88246 12.2282 3.7352 10.3742C4.58793 8.52022 5.84988 6.88368 7.42617 5.58762C9.00245 4.29157 10.8521 3.36974 12.8359 2.89143C14.8198 2.41313 16.8862 2.3908 18.8799 2.82613C20.8737 3.26146 22.7428 4.14311 24.3467 5.40481C25.9506 6.6665 27.2476 8.2754 28.1402 10.1105C29.0328 11.9457 29.4977 13.9593 29.5001 16ZM26.5001 16C26.4995 14.3894 26.1283 12.8006 25.4155 11.3564C24.7026 9.91215 23.667 8.65129 22.3889 7.67133C21.1107 6.69136 19.6243 6.01856 18.0446 5.70495C16.4648 5.39135 14.8341 5.44536 13.2786 5.8628C11.7231 6.28024 10.2844 7.04993 9.07391 8.11232C7.86343 9.1747 6.91356 10.5013 6.29779 11.9895C5.68202 13.4777 5.41686 15.0877 5.52281 16.6947C5.62876 18.3018 6.10299 19.863 6.90882 21.2575C7.01532 21.4414 7.08154 21.6458 7.10309 21.8572C7.12464 22.0686 7.10103 22.2821 7.03382 22.4837L5.79257 26.2075L9.51631 24.9662C9.6695 24.9152 9.82986 24.889 9.99132 24.8887C10.2548 24.8892 10.5134 24.959 10.7413 25.0912C12.3376 26.0149 14.149 26.5018 15.9932 26.503C17.8375 26.5042 19.6495 26.0196 21.247 25.098C22.8445 24.1765 24.171 22.8504 25.0932 21.2532C26.0154 19.6561 26.5006 17.8442 26.5001 16Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className={styles.quotesItemImg}>
                      {item.image ? (
                        <QuoteImage code={item.code} />
                      ) : (
                        <img
                          src="/imgs/upload/wisercam image.png"
                          alt="Service"
                        />
                      )}
                    </div>
                    <div className={styles.quotesAttribute}>
                      <div>رد شده</div>
                      <div>
                        <p>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#367CFF"
                            />
                          </svg>
                          سفارش شما به دلیل مشکلات فنی یا عدم توانایی ساخت توسط
                          کارشناس رد شده است.
                        </p>
                      </div>
                      <div>
                        <Link
                          to={`/DetailOrder/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.quotesitem.button_1}
                          <svg
                            className="d-none d-md-flex"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                              fill="white"
                            />
                          </svg>
                        </Link>
                        <button
                          className="main-btn main-btn-fill disabled:bg-neutral-500"
                          disabled
                        >
                          {content.quotesitem.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Notfound />
            )}
          </div>
        ) : null}

        {tab === "e" ? (
          <div className={styles.quotesBody}>
            {loading ? (
              <div className="d-flex justify-content-center px-2 py-5 h3">
                لطفاً صبر کنید...
              </div>
            ) : dataExpired.length > 0 ? (
              dataExpired.map((item, index) => (
                <div className={styles.quotesItem} key={index}>
                  <button>
                    <input
                      type="checkbox"
                      id={index}
                      name={index}
                      checked={checkSelectServiceHandeler(item.code)}
                      onChange={() => selectServiceHandeler(item.code)}
                    />
                    <label htmlFor={index}>
                      {content.quotesitem.service} {index + 1}{" "}
                    </label>
                  </button>
                  <div className={styles.quotesItemBody}>
                    <div className={styles.quotesItemInfo}>
                      <div>
                        <p>
                          {content.quotesitem.ordercode}&nbsp;
                          {item.code}
                        </p>
                        <p>
                          {content.quotesitem.producttype}&nbsp; ماشین کاری cnc
                        </p>
                        <p>
                          {content.quotesitem.datepreparation}&nbsp;
                          {item.preparation_time
                            ? `${item.preparation_time} روز کاری`
                            : "مشخص نشده"}
                        </p>
                        <p>
                          {content.quotesitem.number}&nbsp;
                          {item.quantity}
                        </p>
                        <p>
                          {content.quotesitem.unitprice}&nbsp;
                          <span
                            className={`${
                              !item.unit_price ? "text-primary" : ""
                            }`}
                          >
                            {item.unit_price
                              ? Number.isNaN(Number(item.unit_price))
                                ? item.unit_price
                                : `${Number(
                                    item.unit_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                        <p>
                          {content.quotesitem.totalprice}&nbsp;
                          <span
                            className={`${
                              !item.total_price ? "text-primary" : ""
                            }`}
                          >
                            {item.total_price
                              ? Number.isNaN(Number(item.total_price))
                                ? item.total_price
                                : `${Number(
                                    item.total_price
                                  ).toLocaleString()} تومان`
                              : "در انتظار تایید"}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          {content.quotesitem.dateregistration}&nbsp;
                          {item.created_at
                            ? moment(item.created_at, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                        <p>
                          تاریخ تایید :&nbsp;
                          {item.accept_date
                            ? moment(item.accept_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                        <p>
                          تاریخ انقضا :&nbsp;
                          {item.expire_date
                            ? moment(item.expire_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            : "مشخص نشده"}
                        </p>
                      </div>
                      <div>
                        {item.is_offline === "0" ? (
                          <button className={styles.success}>
                            بررسی اتوماتیک و آنلاین
                          </button>
                        ) : (
                          <button className={styles.warning}>
                            بررسی آفلاین توسط کارشناس
                          </button>
                        )}
                        <button
                          onClick={() => swalServiceDeletHandeler(item.code)}
                        >
                          {content.quotesitem.removequote}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => swalServiceRetrieveHandeler(item)}
                        >
                          {content.quotesitem.requotation}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30.5009 6.99998V13C30.5009 13.3978 30.3429 13.7793 30.0616 14.0606C29.7803 14.3419 29.3988 14.5 29.0009 14.5H23.0009C22.6031 14.5 22.2216 14.3419 21.9403 14.0606C21.659 13.7793 21.5009 13.3978 21.5009 13C21.5009 12.6022 21.659 12.2206 21.9403 11.9393C22.2216 11.658 22.6031 11.5 23.0009 11.5H25.1384L22.7634 9.32748C22.7472 9.31248 22.7309 9.29748 22.7159 9.28123C21.6147 8.18068 20.2599 7.36764 18.7706 6.91365C17.2814 6.45967 15.7034 6.37865 14.1755 6.67773C12.6476 6.97681 11.2167 7.64682 10.0085 8.6288C8.80036 9.61079 7.85207 10.8747 7.24708 12.3092C6.64208 13.7437 6.39893 15.305 6.53901 16.8555C6.67909 18.4061 7.19811 19.8985 8.0504 21.2014C8.9027 22.5043 10.0621 23.5777 11.4267 24.3273C12.7913 25.0769 14.3192 25.4796 15.8759 25.5H16.0009C18.4258 25.5058 20.76 24.5784 22.5197 22.91C22.8089 22.6366 23.1949 22.4894 23.5927 22.5007C23.9906 22.5119 24.3676 22.6807 24.6409 22.97C24.9143 23.2592 25.0615 23.6452 25.0503 24.043C25.039 24.4408 24.8702 24.8179 24.5809 25.0912C22.2645 27.2867 19.1925 28.5073 16.0009 28.5H15.8297C13.7835 28.4711 11.7757 27.9404 9.98254 26.9543C8.1894 25.9682 6.66578 24.557 5.54546 22.8445C4.42514 21.132 3.7424 19.1706 3.55717 17.1326C3.37195 15.0946 3.68991 13.0423 4.48314 11.1559C5.27637 9.26953 6.5206 7.60673 8.10659 6.31352C9.69257 5.02032 11.5718 4.13628 13.5793 3.73902C15.5867 3.34176 17.661 3.44343 19.62 4.03511C21.579 4.62679 23.3628 5.69037 24.8147 7.13248L27.5009 9.58998V6.99998C27.5009 6.60216 27.659 6.22062 27.9403 5.93932C28.2216 5.65802 28.6031 5.49998 29.0009 5.49998C29.3988 5.49998 29.7803 5.65802 30.0616 5.93932C30.3429 6.22062 30.5009 6.60216 30.5009 6.99998Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => swalReorderingrHandeler(item.code)}
                        >
                          {content.quotesitem.copyquote}

                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 3.5H11C10.6022 3.5 10.2206 3.65804 9.93934 3.93934C9.65804 4.22064 9.5 4.60218 9.5 5V9.5H5C4.60218 9.5 4.22064 9.65804 3.93934 9.93934C3.65804 10.2206 3.5 10.6022 3.5 11V27C3.5 27.3978 3.65804 27.7794 3.93934 28.0607C4.22064 28.342 4.60218 28.5 5 28.5H21C21.3978 28.5 21.7794 28.342 22.0607 28.0607C22.342 27.7794 22.5 27.3978 22.5 27V22.5H27C27.3978 22.5 27.7794 22.342 28.0607 22.0607C28.342 21.7794 28.5 21.3978 28.5 21V5C28.5 4.60218 28.342 4.22064 28.0607 3.93934C27.7794 3.65804 27.3978 3.5 27 3.5ZM19.5 25.5H6.5V12.5H19.5V25.5ZM25.5 19.5H22.5V11C22.5 10.6022 22.342 10.2206 22.0607 9.93934C21.7794 9.65804 21.3978 9.5 21 9.5H12.5V6.5H25.5V19.5Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => {
                            setTalkExpert(item.code);
                            navigate(`/DetailsTicket/${item.ticket_code}`);
                          }}
                        >
                          {content.quotesitem.talkexpert}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.5001 13.5C21.5001 13.8978 21.342 14.2793 21.0607 14.5606C20.7794 14.8419 20.3979 15 20.0001 15H12.0001C11.6022 15 11.2207 14.8419 10.9394 14.5606C10.6581 14.2793 10.5001 13.8978 10.5001 13.5C10.5001 13.1021 10.6581 12.7206 10.9394 12.4393C11.2207 12.158 11.6022 12 12.0001 12H20.0001C20.3979 12 20.7794 12.158 21.0607 12.4393C21.342 12.7206 21.5001 13.1021 21.5001 13.5ZM20.0001 17H12.0001C11.6022 17 11.2207 17.158 10.9394 17.4393C10.6581 17.7206 10.5001 18.1021 10.5001 18.5C10.5001 18.8978 10.6581 19.2793 10.9394 19.5606C11.2207 19.8419 11.6022 20 12.0001 20H20.0001C20.3979 20 20.7794 19.8419 21.0607 19.5606C21.342 19.2793 21.5001 18.8978 21.5001 18.5C21.5001 18.1021 21.342 17.7206 21.0607 17.4393C20.7794 17.158 20.3979 17 20.0001 17ZM29.5001 16C29.5006 18.3124 28.907 20.5862 27.7764 22.6034C26.6458 24.6206 25.0159 26.3136 23.0431 27.52C21.0703 28.7264 18.8207 29.4059 16.5099 29.4932C14.199 29.5805 11.9045 29.0728 9.84631 28.0187L5.79257 29.375C5.35127 29.5237 4.8772 29.5462 4.42379 29.44C3.97038 29.3337 3.55566 29.103 3.22637 28.7737C2.89708 28.4444 2.66631 28.0297 2.56007 27.5762C2.45383 27.1228 2.47634 26.6488 2.62507 26.2075L3.97632 22.1537C3.04843 20.3362 2.54466 18.3319 2.5029 16.2917C2.46114 14.2514 2.88246 12.2282 3.7352 10.3742C4.58793 8.52022 5.84988 6.88368 7.42617 5.58762C9.00245 4.29157 10.8521 3.36974 12.8359 2.89143C14.8198 2.41313 16.8862 2.3908 18.8799 2.82613C20.8737 3.26146 22.7428 4.14311 24.3467 5.40481C25.9506 6.6665 27.2476 8.2754 28.1402 10.1105C29.0328 11.9457 29.4977 13.9593 29.5001 16ZM26.5001 16C26.4995 14.3894 26.1283 12.8006 25.4155 11.3564C24.7026 9.91215 23.667 8.65129 22.3889 7.67133C21.1107 6.69136 19.6243 6.01856 18.0446 5.70495C16.4648 5.39135 14.8341 5.44536 13.2786 5.8628C11.7231 6.28024 10.2844 7.04993 9.07391 8.11232C7.86343 9.1747 6.91356 10.5013 6.29779 11.9895C5.68202 13.4777 5.41686 15.0877 5.52281 16.6947C5.62876 18.3018 6.10299 19.863 6.90882 21.2575C7.01532 21.4414 7.08154 21.6458 7.10309 21.8572C7.12464 22.0686 7.10103 22.2821 7.03382 22.4837L5.79257 26.2075L9.51631 24.9662C9.6695 24.9152 9.82986 24.889 9.99132 24.8887C10.2548 24.8892 10.5134 24.959 10.7413 25.0912C12.3376 26.0149 14.149 26.5018 15.9932 26.503C17.8375 26.5042 19.6495 26.0196 21.247 25.098C22.8445 24.1765 24.171 22.8504 25.0932 21.2532C26.0154 19.6561 26.5006 17.8442 26.5001 16Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className={styles.quotesItemImg}>
                      {item.image ? (
                        <QuoteImage code={item.code} />
                      ) : (
                        <img
                          src="/imgs/upload/wisercam image.png"
                          alt="Service"
                        />
                      )}
                    </div>
                    <div className={styles.quotesAttribute}>
                      <div>منقضی شده</div>
                      <div>
                        <p>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#367CFF"
                            />
                          </svg>
                          مظنه‌ی شما به دلیل گذشت مدت زمان طولانی منقضی شده است.
                          برای محاسبه مجدد قیمت و زمان تحویل از گزینه “مظنه‌گیری
                          مجدد” استفاده کنید.
                        </p>
                      </div>
                      <div>
                        <Link
                          to={`/DetailOrder/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.quotesitem.button_1}
                          <svg
                            className="d-none d-md-flex"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                              fill="white"
                            />
                          </svg>
                        </Link>
                        <button
                          className="main-btn main-btn-fill disabled:bg-neutral-500"
                          disabled
                        >
                          {content.quotesitem.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Notfound />
            )}
          </div>
        ) : null}
      </section>
    </MainLayout>
  );
};

export default Quotes;
